import SortOption from '~/constants/common/SortOption';

export const SortOptionsWithLabels = [
  { label: 'Recommended', key: SortOption.MostPopular },
  { label: 'Lowest monthly', key: SortOption.MonthlyPayment },
  { label: 'Lowest cash down', key: SortOption.CashDue },
  { label: 'Lowest price', key: SortOption.LowestPrice },
  { label: 'Highest price', key: SortOption.HighestPrice },
  { label: 'Soonest availability', key: SortOption.AcquisitionTime },
  { label: 'Lowest shipping cost', key: SortOption.FreeShipping },
  { label: 'Lowest mileage', key: SortOption.LowestMileage },
  { label: 'Newest inventory', key: SortOption.NewestInventory },
  { label: 'Newest year', key: SortOption.NewestYear }
];

export const validSoftPullSortOptions = [
  SortOption.CashDue,
  SortOption.MonthlyPayment
];
